import { Ref, unref } from 'vue';
import { License, LicenseUsage } from '../../types';
import { LicensePageTabName } from '../tabs';
import { findLicensePageTabViewRendererByName } from './utils';

export function useLicensePageTabViewRenderer(tabName: Ref<LicensePageTabName>, license: Ref<License>, licenseUsage: Ref<LicenseUsage>) {
  return () => findLicensePageTabViewRendererByName(unref(tabName))(unref(license), unref(licenseUsage));
}
